import { Check } from "lucide-react";
import { PORTAL } from "@/data/content";
import { Reveal } from "./Reveal";

export const Portal = () => (
  <section className="relative border-t border-white/10 py-28 md:py-40" data-testid="portal">
    <div className="ec-container grid grid-cols-1 items-center gap-14 lg:grid-cols-2">
      <Reveal>
        <p className="ec-eyebrow mb-4">
          <span className="h-1.5 w-1.5 rounded-full bg-[#D4F870]" />
          {PORTAL.eyebrow}
        </p>
        <h2 className="font-display text-4xl leading-[1.03] tracking-tight text-[#F3F4F6] sm:text-5xl">
          {PORTAL.title}
        </h2>
        <p className="mt-6 max-w-lg text-base leading-relaxed text-[#9CA3AF]">{PORTAL.text}</p>
        <ul className="mt-8 space-y-4">
          {PORTAL.bullets.map((b) => (
            <li key={b} className="flex items-center gap-3 text-[#F3F4F6]">
              <span className="grid h-6 w-6 place-items-center rounded-full bg-[#D4F870]/15 text-[#D4F870]">
                <Check className="h-3.5 w-3.5" />
              </span>
              <span className="text-sm md:text-base">{b}</span>
            </li>
          ))}
        </ul>
      </Reveal>

      <Reveal delay={0.12}>
        <div className="relative">
          <div className="absolute -inset-4 -z-10 rounded-3xl bg-[#D4F870]/5 blur-2xl" />
          <div className="overflow-hidden rounded-2xl border border-white/10">
            <img
              src={PORTAL.image}
              alt="Danışman müşteri portalı"
              className="h-full w-full object-cover grayscale transition-all duration-700 hover:grayscale-0"
              data-testid="portal-image"
            />
          </div>
          <div className="absolute bottom-4 left-4 rounded-xl border border-white/10 bg-[#0A0A0A]/85 px-4 py-3 backdrop-blur-md">
            <div className="font-display text-xl text-[#D4F870]">12+ müşteri</div>
            <div className="text-xs text-[#9CA3AF]">tek panelden yönetiliyor</div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
